import React from 'react';

export const Logo = ({ className = "", size = "md", iconOnly = false }) => {
    const sizes = {
        sm: { h: "h-6", text: "text-lg" },
        md: { h: "h-10", text: "text-2xl" },
        lg: { h: "h-16", text: "text-4xl" }
    };
    const current = sizes[size] || sizes.md;

    if (iconOnly) {
        return (
            <img src="/assets/branding/LogoOficial.png" alt="PrimeApuesta" className={`${current.h} object-contain rounded-xl ${className}`} />
        );
    }

    return (
        <img src="/assets/branding/bannerLogoOficial.png" alt="PrimeApuesta" className={`${current.h} object-contain mix-blend-lighten ${className}`} />
    );
};

export const Card = ({ children, className = "", title }) => (
    <div className={`bg-[#252525] border border-white/5 rounded-2xl overflow-hidden shadow-xl ${className}`}>
        {title && (
            <div className="bg-white/5 px-5 py-3 border-b border-white/5">
                <h4 className="text-[10px] font-black uppercase text-neutral-400 tracking-widest">{title}</h4>
            </div>
        )}
        <div className="p-5">{children}</div>
    </div>
);

export const KpiCard = ({ title, value, trend, color = "text-white", icon: Icon, alert }) => (
    <div className="bg-[#252525] border border-white/5 p-5 rounded-2xl relative overflow-hidden group hover:border-[#F59E0B]/20 transition-all">
        <div className="flex justify-between items-start mb-4">
            <div className="p-2.5 rounded-lg bg-neutral-800 text-[#F59E0B] group-hover:bg-[#F59E0B] group-hover:text-black transition-colors duration-300">
                {Icon && <Icon size={20} />}
            </div>
            {trend && (
                <span className={`text-[10px] font-bold px-2 py-1 rounded-full ${trend.startsWith('+') ? 'bg-emerald-500/10 text-emerald-500' : 'bg-red-500/10 text-red-500'}`}>
                    {trend}
                </span>
            )}
        </div>
        <p className="text-neutral-500 text-[10px] uppercase font-black tracking-widest mb-1">{title}</p>
        <h3 className={`text-2xl font-black font-mono ${color}`}>{value}</h3>
        <div className="absolute bottom-0 right-0 w-24 h-12 opacity-5 bg-gradient-to-t from-[#F59E0B] to-transparent"></div>
    </div>
);

export const PrimaryButton = ({ children, onClick, loading, disabled, className = "", icon: Icon }) => (
    <button
        onClick={onClick}
        disabled={disabled || loading}
        className={`w-full gold-gradient hover:brightness-110 text-black font-black uppercase spacing-widest px-8 py-5 rounded-full transition-all flex items-center justify-center gap-3 group shadow-2xl shadow-[#F59E0B]/20 active:scale-[0.98] border-none disabled:opacity-50 ${className}`}
    >
        {loading ? <div className="w-5 h-5 border-2 border-black/30 border-t-black rounded-full animate-spin"></div> : Icon && <Icon size={20} strokeWidth={3} />}
        <span>{children}</span>
    </button>
);

export const AdminButton = ({ children, onClick, active, icon: Icon, className = "" }) => (
    <button
        onClick={onClick}
        className={`w-full flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-all group ${active
            ? 'bg-[#F59E0B] text-black font-bold shadow-[0_0_15px_rgba(245,158,11,0.3)]'
            : 'text-neutral-400 hover:bg-white/5 hover:text-white'
            } ${className}`}
    >
        {Icon && <Icon size={20} className={active ? 'text-black' : 'text-neutral-500 group-hover:text-white transition'} />}
        {children}
    </button>
);

export const ActionButton = ({ children, onClick, color = "gold", icon: Icon, className = "" }) => {
    const colors = {
        gold: "bg-[#F59E0B]/10 text-[#F59E0B] border-[#F59E0B]/20 hover:bg-[#F59E0B] hover:text-black",
        emerald: "bg-emerald-500/10 text-emerald-500 border-emerald-500/20 hover:bg-emerald-500 hover:text-black",
        red: "bg-red-500/10 text-red-500 border-red-500/20 hover:bg-red-500 hover:text-white",
        slate: "bg-slate-800/50 text-slate-400 border-white/5 hover:bg-slate-700 hover:text-white"
    };

    return (
        <button
            onClick={onClick}
            className={`p-2.5 rounded-xl border transition-all duration-300 active:scale-90 ${colors[color] || colors.gold} ${className}`}
        >
            {Icon && <Icon size={16} />}
            {children}
        </button>
    );
};

export const Badge = ({ type, children }) => {
    const types = {
        success: 'bg-emerald-500/10 text-emerald-500 border-emerald-500/20',
        danger: 'bg-red-500/10 text-red-500 border-red-500/20',
        warning: 'bg-[#F59E0B]/10 text-[#F59E0B] border-[#F59E0B]/20',
        neutral: 'bg-white/5 text-neutral-400 border-white/5'
    };
    return (
        <span className={`text-[10px] font-bold px-2 py-0.5 rounded border uppercase tracking-wider ${types[type] || types.neutral}`}>
            {children}
        </span>
    );
};
